let pick_data4 = [
    {
        id : 96,
        imgurl : '/img/section7/section7_shoe1.jpg',
        brand : 'S.T.DUPONT CLASSICS SHOES',
        title : '제트 남성 캐주얼 631 스니커즈',
        persent : '10%',
        price : '359,000',
        saleprice : '323,100',
    },
    {
        id : 97,
        imgurl : '/img/section7/section7_shoe2.jpg',
        brand : 'KEEN',
        title : '블랙 남성 슬라이드',
        persent : '10%',
        price : '99,000',
        saleprice : '89,100',
    },
    {
        id : 98,
        imgurl : '/img/section7/section7_shoe3.jpg',
        brand : 'DAKS ACC',
        title : '여성 프리미엄 클로슈햇',
        persent : '5%',
        price : '198,000',
        saleprice : '188,100',
    },
    {
        id : 99,
        imgurl : '/img/section7/section7_shoe4.jpg',
        brand : 'PLEATS MAMA',
        title : '에어니트 노트북파우치 딥그린',
        persent : '',
        price : '',
        saleprice : '49,000',
    },
    {
        id : 100,
        imgurl : '/img/section7/section7_shoe5.jpg',
        brand : 'KEEN',
        title : '그레이 남성 슬라이드',
        persent : '19%',
        price : '99,000',
        saleprice : '80,190',
    },
    {
        id : 101,
        imgurl : '/img/section7/section7_shoe6.jpg',
        brand : 'VETIANO',
        title : 'Pastel Bold Chain Blooper',
        persent : '25%',
        price : '239,000',
        saleprice : '178,950',
    },
    {
        id : 102,
        imgurl : '/img/section7/section7_shoe7.jpg',
        brand : 'RHEEMIN',
        title : 'PUPPY BUCKET CROSS NUGGET',
        persent : '10%',
        price : '159,000',
        saleprice : '143,100',
    },
    {
        id : 103,
        imgurl : '/img/section7/section7_shoe8.jpg',
        brand : 'S.T.DUPONT CLASSICS SHOES',
        title : '제트 남성 캐주얼 835 애슬래틱',
        persent : '40%',
        price : '359,000',
        saleprice : '215,400',
    }
]

export default pick_data4;